module.exports = __webpack_public_path__ + "static/media/download_icon.fd7f4d25.svg";